
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  content: '',
  color: ''
})

const mutations = {
  showMessage (state, payload) {
    state.content = payload.content
    state.color = payload.color
  }
}

export default {
  state,
//  getters,
//  actions,
  mutations
}
